import { Tooltip as DsTooltip } from '@natter-co/design-system';
import { VISUAL_REFRESH } from 'common/utils';

import { TooltipProps as MuiTooltipProps, Tooltip } from '../../Tooltip';
import { IconButton, IconButtonProps } from '../IconButton';
import { toDsTooltipProps } from './toDsTooltipProps';

export type IconButtonWithTooltipProps = IconButtonProps &
  Pick<MuiTooltipProps, 'title'> & {
    TooltipProps?: Omit<MuiTooltipProps, 'children' | 'title'>;
  };

export const IconButtonWithTooltip = ({ title, TooltipProps, ...iconButtonProps }: IconButtonWithTooltipProps) => {
  // The visual-refresh gate lives here, not at the call sites. `null` falls through to MUI.
  const dsTooltipProps = VISUAL_REFRESH
    ? toDsTooltipProps({ title, TooltipProps, disabled: iconButtonProps.disabled })
    : null;

  if (dsTooltipProps) {
    return (
      <DsTooltip {...dsTooltipProps}>
        <IconButton aria-label={dsTooltipProps.label} {...iconButtonProps} />
      </DsTooltip>
    );
  }

  return (
    <Tooltip title={title} display="flex" {...TooltipProps}>
      <IconButton aria-label={title} {...iconButtonProps} />
    </Tooltip>
  );
};
